import { get } from '../helpers/objectHelper';
import dayjs from 'dayjs';
import _last from 'lodash/last';
import _head from 'lodash/head';
import _sumBy from 'lodash/sumBy';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(AdvancedFormat);


/**
* Number of Stops
*
* @param {object} payload - itinerary payload
*/
export function numItineraryStops(payload){
  return _sumBy(payload, (item) => { return item.type === "city"}) || 0;
}


/**
* Number of Itinerary days
*
* @param {object} payload - itinerary payload
*/
export function numItineraryDays(payload){
  return _sumBy(payload, (item) => { return ((item.type === "city" || item.type === "start") && item.nights !== null) ? item.nights : 0 });
}

/**
* Number of Accommodation nights (not products accommodation night)
*
* @param {object} payload - itinerary payload
*/
export function numAccommodationNights(payload){
  return _sumBy(payload, (item) => { return ((item.type === "city" || item.type === "start") && item.accommodation.reservations !== null && item.accommodation.nights !== null) ? item.accommodation.nights : 0 })
}

/**
* Number of Products
*
* @param {object} payload - itinerary payload
*/
export function numProductNights(payload){
  return _sumBy(payload, (item) => { return (item.type === "product" && item.nights !== null) ? item.nights : 0 });
}

/**
* Number of nights list
*
* @param {object} type - odd or even
* @param {object} num - total number count
*/
export function renderNightList(type = "all", num = 11){

    let arr = [];

    for(let i = 1; i < num; i++){
      if(type === "all"){
        arr.push(`${i} nights`);
      }
      if(type === "even"){
        if(i % 2 === 0) arr.push(`${i} nights`);
      }
      if(type === "odd"){
        if(i % 2 === i) return arr.push(`${i} nights`);
      }
    }
    return arr;
 }

/**
* Check for gap sector - hide previous extend message
*
* @param {array} itineraryList - itinerary array
*/
 export function checkGapItinerary(itineraryList){

 let arr = [...itineraryList];

 for(let i = 0; i < arr.length; i++){
     if(arr[i].type === "extend" && arr[i+1].type === "start"){
         arr.splice(i, 1);
     }
 }
 return arr;
}

/**
* Check last itinerary item that lands on non-hoho city (last itinerary type is product and no routes)
*
* @param {object} itinerary - itinerary object
* @param {object} routes - routes object
*/
export function checkLastItineraryItem(itinerary, routes){
  
  return (itinerary !== undefined && _last(itinerary).type === "product" && routes.length === 0) ? true : false;
}

/**
* Helper for current active itinerary data
*
* @param {int} currentStop - the current index
* @param {object} currentStop - the itinerary object
*/
export function itineraryListData(currentStop, itinerary){

  const _date = get([currentStop, 'date'], itinerary, "");
  const _type = get([currentStop, 'type'], itinerary);
  const _nextType = get([currentStop+1, 'type'], itinerary);
  const _previousType = get([currentStop-1, 'type'], itinerary);
  const _nights = get([currentStop, 'nights'], itinerary, "0");
  const _reservation = get([currentStop, 'accommodation', 'reservations'], itinerary, "");
  const _totalStops = itinerary !== undefined ? itinerary.length : 0;
  const _startCity = (itinerary.length > 0) ? _head(itinerary).to : "";
  const _lastCity =  (itinerary.length > 0) ? _last(itinerary).to : "";
  const _to = get([currentStop, 'to'], itinerary, "");
  const _name = get([currentStop, 'name'], itinerary, "");
  const _day = numItineraryDays(itinerary) + numProductNights(itinerary); //Include any product day/nights
  const _accommodationNight = numAccommodationNights(itinerary) + numProductNights(itinerary); //Include any product day/nights

  return {
    totalStops: _totalStops,
    type: _type,
    nextType:_nextType,
    previousType:_previousType,
    date: _date,
    nights: _nights,
    days: _day,
    accommodationNight: _accommodationNight,
    stops:numItineraryStops(itinerary),
    startCity:_startCity,
    lastCity:_lastCity,
    isProduct: (_type === "product") ? true : false,
    cityOrProductName: (_type === "start" || _type === "city" || _type === "overnight") ? _to : _name,
    dateDurationStart: dayjs(_date).format("D MMMM YYYY"),
    dateDurationEnd: (_nights === "0") ? "" : ` - ${dayjs(_date).add(_nights,'days').format("D MMMM YYYY")}`,
    hostelName: get([currentStop, 'cityInfo', 'hostel', 0, 'hostelName'], itinerary, ""),
    dormRoom: get([currentStop, 'cityInfo', 'hostel', 0, 'dormRoom'], itinerary, ""),
    arriveTime: get([currentStop, 'arrival'], itinerary, ""),
    nextArriveTime:get([currentStop + 1, 'arrival'], itinerary, ""),
    departTime: get([currentStop, 'departure'], itinerary, ""),
    nextDepartureTime:get([currentStop+1, 'departure'], itinerary, ""),
    address: get([currentStop, 'cityInfo', 'address'], itinerary, "").replace("__", "").replace("__", " -"),
    city: get([currentStop, 'cityInfo', 'hostel', 0, 'city'], itinerary, ""),
    country: get([currentStop, 'cityInfo', 'hostel', 0, 'country'], itinerary, ""),
    nextCity: ((_type === "start" || _type === "city" || _type === "product") && currentStop < _totalStops-1) ? itinerary[currentStop+1].to : "",
    hasNights: (_nights !== "0") ? true : false,
    hostelAccommodation: get([currentStop, 'accommodation', 'options','hostel'], itinerary, ""),
    reservation: _reservation,
    isBackStop: (_nights !== "0") && get([currentStop, 'accommodation', 'reservations', 'name'], itinerary, "") === "Hostel Details TBC" ? true : false,
    productTourId: get([currentStop, 'productInfo', 'tourId'], itinerary, ""),
    productAccommodation:get([currentStop, 'productInfo', 'accommodation'], itinerary, "" ),
    productStartAddress:get([currentStop, 'productInfo', 'startCity', 'address'], itinerary, "").replace("__", "").replace("__", " -"),
    productEndAddress:get([currentStop, 'productInfo', 'endCity', 'address'], itinerary, "").replace("__", "").replace("__", " -")
  }
}




